import { useEffect, useState } from "react";
import { X } from "lucide-react";

const KEY = "giano_cookie_consent_v1";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(KEY);
    if (!stored) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem(KEY, JSON.stringify({ accepted: true, analytics: true, at: new Date().toISOString() }));
    setVisible(false);
  };
  const acceptOnlyEssential = () => {
    localStorage.setItem(KEY, JSON.stringify({ accepted: true, analytics: false, at: new Date().toISOString() }));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      style={{
        position: "fixed", left: 20, right: 20, bottom: 20, zIndex: 90,
        maxWidth: 560, margin: "0 auto",
        background: "var(--midnight)", color: "var(--bone)",
        padding: 20, borderLeft: "3px solid var(--gold)",
        boxShadow: "0 20px 40px rgba(15,23,32,0.35)",
      }}
    >
      <button
        onClick={acceptOnlyEssential}
        aria-label="Chiudi"
        data-testid="cookie-close"
        style={{ position: "absolute", top: 10, right: 10, background: "transparent", border: "none", color: "var(--bone)", cursor: "pointer", opacity: 0.6 }}
      >
        <X size={16} />
      </button>
      <div className="font-mono text-xs" style={{ color: "var(--gold)", letterSpacing: 1 }}>PRIVACY · COOKIE</div>
      <p className="mt-2 text-sm" style={{ lineHeight: 1.6, opacity: 0.9 }}>
        Usiamo cookie tecnici essenziali per far funzionare il sito e, con il tuo consenso, cookie analitici anonimi per capire come viene usato. Nessun dato personale è profilato o venduto.
      </p>
      <div className="mt-4 flex flex-wrap gap-2">
        <button
          onClick={accept}
          data-testid="cookie-accept-all"
          className="btn-primary"
          style={{ background: "var(--gold)", color: "var(--midnight)", borderColor: "var(--gold)", fontSize: 13, padding: "8px 16px" }}
        >
          Accetto tutti
        </button>
        <button
          onClick={acceptOnlyEssential}
          data-testid="cookie-accept-essential"
          className="btn-ghost"
          style={{ color: "var(--bone)", borderColor: "rgba(255,255,255,0.3)", fontSize: 13, padding: "8px 16px" }}
        >
          Solo essenziali
        </button>
        <a
          href="/privacy"
          className="text-xs font-mono"
          style={{ color: "var(--gold)", textDecoration: "underline", textUnderlineOffset: 3, alignSelf: "center", marginLeft: 6 }}
        >
          Informativa completa
        </a>
      </div>
    </div>
  );
}
